export default __webpack_public_path__ + "static/restaurant-interior-6c2dc7f6cc3cd364184b1e01706e8ed2.jpeg";